export const SOCKET_EVENT_NAMES = [
  'BOOKING_CREATE',
  'BOOKING_UPDATE',
  'BOOKING_UPDATE_ACCEPTED',
  'BOOKING_DELETE',
  'BOOKING_REFUSE',
  'BOOKING_PENDING',
  'BOOKING_REFRESH',
  'BOOKING_REFUSE_UPDATE_BY_CUSTOMER',
  'ARRIVED',
  'BOOKING_CONFIRM',
  'UPDATE_AMENITY_ORDER',
  'TABLE_CREATE',
  'TABLE_UPDATE',
  'ROOM_REFRESH',
  'TABLE_DELETE',
] as const;

export type SocketEventName = (typeof SOCKET_EVENT_NAMES)[number];

export type SocketEventEnvelope<TPayload = unknown> = {
  event?: string;
  type?: string;
  eventName?: string;
  branchCode?: string;
  bookingCode?: string;
  payload?: TPayload;
  data?: TPayload;
  [key: string]: unknown;
};

export type SocketPayloadContext = {
  branchCode?: string;
  bookingCode?: string;
  bookingDate?: string;
  bookingDateAfterUpdate?: string;
  updateType?: string;
  roomCode?: string;
  tableCode?: string;
};
